/**
 * Injeção do `PlatformApiClient` na árvore React (Task 10).
 *
 * As páginas nunca constroem um cliente próprio nem leem env: elas pedem o
 * cliente ao contexto. Isso mantém uma única porta de I/O e deixa o teste
 * injetar um cliente apontado para um servidor efêmero.
 */
import { createContext, createElement as h, useContext, type ReactElement, type ReactNode } from "react";
import { PlatformApiClient } from "./platform-client.js";

const ApiClientContext = createContext<PlatformApiClient | null>(null);

export function useApiClient(): PlatformApiClient {
  const client = useContext(ApiClientContext);
  if (!client) throw new Error("api_client_not_provided");
  return client;
}

export interface ApiClientProviderProps {
  client: PlatformApiClient;
  children: ReactNode;
}

export function ApiClientProvider({ client, children }: ApiClientProviderProps): ReactElement {
  return h(ApiClientContext.Provider, { value: client }, children);
}
